import type { User } from 'types'

const hashCode = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return hash
}

export const getUserColor = (userId?: string | null) => {
  if (!userId) {
    return 'transparent'
  }
  return `hsl(${hashCode(userId) % 360}, 100%, 30%)`
}

export const getUserInitials = (firstName?: string | null, lastName?: string | null) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : ''
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : ''
  return `${firstInitial}${lastInitial}`
}

export const sortCurrentUserFirst = <T extends User>(users: T[], currentUser: User): T[] => {
  const current = users.find(u => u.id === currentUser.id)
  const sortedOthers = users
    .filter(u => u.id !== currentUser.id)
    .sort((a, b) => getUserName(a).localeCompare(getUserName(b)))
  return [current, ...sortedOthers].filter((u): u is T => Boolean(u))
}

export const getUserName = (user: User | null, showTag = false) => {
  if (!user) return 'myQAP Automation'

  const { firstName, lastName, email, tags = [] } = user

  const name = [firstName, lastName].filter(Boolean).join(' ').trim() || email
  const tagStr = showTag && tags.length ? ` (${tags.map(({ name }) => name).join(', ')})` : ''

  return `${name}${tagStr}`
}
